/* tslint:disable */

/**
 */
export class AppNotifyInputForm {
    style_search?: string;
    key_input?: string;
}
